<template>
    <v-row no-gutters class="mt-3">
        <v-col cols="auto">
            <div :class="canEditTemplate ? 'd-inline' : 'd-none'">
                <RichTextEditorToolbar id="email-automation-content-toolbar" />
            </div>
            <v-btn
                v-if="canEditTemplate && allowAttachments"
                icon
                text
                class="mr-0 ml-0"
                color="n3"
                @click="$emit('addAttachment')"
            >
                <v-icon
                    :size="24"
                    color="n3"
                >
                    mdi-paperclip
                </v-icon>
            </v-btn>
            <RichTextEditorPlaceholders v-if="canEditTemplate" :rich-text-editor="richTextEditor" />
            <action-menu v-if="actionItems.length" :items="actionItems" @action="actionItems[$event].action()" />
        </v-col>
        <v-col cols="auto" class="ml-auto">
            <v-btn
                text
                color="n4"
                @click="$emit('cancel')"
            >
                {{ $t("Cancel") }}
            </v-btn>
            <v-btn
                class="primary inverted--text"
                :disabled="!canEditTemplate"
                :loading="isSaving"
                @click="$emit('save')"
            >
                {{ $t("Save") }}
            </v-btn>
        </v-col>
    </v-row>
</template>

<script>
import { $t } from "@/i18n";
import { ref, computed } from "@vue/composition-api";
import DialogModule from "../../../store/modules/dialog";
import RichTextEditorToolbar from "../../../components/RichTextEditor/RichTextEditorToolbar";
import RichTextEditorPlaceholders from "../../../components/RichTextEditor/RichTextEditorPlaceholders";

export default {
    name: "EditTemplateFooter",
    components: {
        RichTextEditorToolbar,
        RichTextEditorPlaceholders
    },
    props: {
        canEditTemplate: {
            type: Boolean,
            required: true
        },
        canDeleteTemplate: {
            type: Boolean,
            required: true
        },
        isSaving: {
            type: Boolean,
            required: true
        },
        allowAttachments: {
            type: Boolean,
            required: true
        },
        richTextEditor: {
            type: Object,
            default: null
        }
    },
    setup(props, ctx) {
        const { openConfirmDialog, setConfirmOptions } = DialogModule();

        const actionItems = computed(() => {
            let items = []

            if (props.canDeleteTemplate) {
                items.push({
                    text: $t("Delete template"),
                    action: () => onDeleteClick()
                })
            }

            return items
        })

        const onDeleteClick = () => {
            setConfirmOptions({
                title: $t("Are you sure you want to delete this template?"),
                confirm_text: $t("Delete"),
                cancel_text: $t("Cancel"),
                action: () => ctx.emit('delete')
            });
            openConfirmDialog();
        };


        return {
            actionItems
        }
    }
}
</script>

<style scoped>
.format-button.ql-active .v-icon {
    color: var(--v-n4-base) !important;
}
</style>